import { render, staticRenderFns } from "./CreateWhatsapp.vue?vue&type=template&id=c0d00a7a&scoped=true&"
import script from "./CreateWhatsapp.vue?vue&type=script&lang=js&"
export * from "./CreateWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./CreateWhatsapp.vue?vue&type=style&index=0&id=c0d00a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d00a7a",
  null
  
)

export default component.exports